module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w720.3b005191.jpg";